import React, { useState, useEffect } from 'react';
import { useParams, Redirect } from "react-router-dom";
//import PDFViewer from 'pdf-viewer-reactjs';
import LoadingModal from '../Components/LoadingModal';
import { GetIndexHospital, GetBaseUrl } from '../AppConfig';
import { getReporteCuenta } from '../Services/Net/Request/CuentaService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Button from 'react-bootstrap/Button'

export default function PdfAccountPage()
{
    let { idcuenta } = useParams();
    const [loading, setLoading] = useState("");
    const [urldoc, setUrldoc] = useState("?");

    useEffect(() => {
        setLoading(true);
        const hospital = GetIndexHospital() === 0 ? "Hospital Real San Jose":"Hospital Real San Jose Valle";
        var promise = getReporteCuenta(null,hospital,idcuenta);
        promise.then(
            (response) =>{
              if (response.ok)
              {
                response.json().then((data) => {
                    const rute = GetBaseUrl()+data.url_pdf;
                    setUrldoc(GetBaseUrl()+"pdfviwer/web/viewer.html?file="+rute);
                    setLoading(false);
                });
              } else {
                setLoading(false);
                alert("No se logro generar el reporte");
                setUrldoc("");
              }
            }
          ).catch(function(error) 
          { 
              setLoading(false); 
              alert("No se logro generar el reporte"); 
              setUrldoc("");
          });
    },[setLoading,idcuenta]);

    function CloseReport()
    {
        setUrldoc("");
    }

    if (urldoc === "?")
    {
        return(
            <LoadingModal show={loading}/>
        );
    } else if (urldoc !== "")
    {
        return(
            <section className="h100">
                <div className="btnclose">
                    <Button variant="danger" onClick={() => CloseReport()}>
                        <FontAwesomeIcon icon={faTimes}/>
                    </Button>
                </div>
                <iframe className="rviwer"
                        src={urldoc} 
                        title="Report Viwer"> 
                </iframe>
            </section>
        );
    } else {
        return(
            <Redirect
            to={{
            pathname: "/login"}}/>
            );
    }
}